import React, { FunctionComponent } from 'react';

const TopbarMenuItem: FunctionComponent<{
  label: string;
}> = (props) => <span className='body2 medium neutral700'>{props.label}</span>;

export default TopbarMenuItem;
